import React, { Component } from 'react';
import { tween } from 'shifty';

class VisWat extends Component {

	state = {
		staticX: 500,
		dynamicX: -200
	}


	componentDidMount(){
		if (this.props.previousStep === 5) this.setState({ staticX: 0, dynamicX: 0 });
		this.mounted = true;
	}

	componentWillUnmount(){
		this.mounted = false;
	}

  componentWillReceiveProps(nextProps){
  	const easing = 'easeInOutCubic';
  	if (nextProps.currentStep === 3 && nextProps.previousStep === 2){
	  		tween({
			    from: { x: 500},
			    to: { x: 0 },
			    duration: 500,
			    easing: easing,
			    step: state => { if (this.mounted) this.setState({ staticX: state.x  }) }
	  	});
  	}

  	if (nextProps.currentStep === 4 && nextProps.previousStep === 3){
	  		tween({
			    from: { x: -200},
			    to: { x: 0 },
			    duration: 500,
			    easing: easing,
			    step: state => { if (this.mounted) this.setState({ dynamicX: state.x  }) }
	  	});
  	}

  }

  render(){

		const { currentStep } = this.props;

		const invissible  = {
			opacity: 0,
			transition: 'opacity 1s ease'
		};
		const vissible  = {
			opacity: 1,
	    transition: 'opacity 1s ease'
		};

		const styleCloudStatic = (currentStep < 3) ? invissible : vissible;
		const styleCloudDynamic = (currentStep < 4) ? invissible : vissible;

	  return (

			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 360">
			  <title>Wat is koopkracht?</title>
			  <g fontFamily="RijksoverheidSansText-Regular, RijksoverheidSansText, Arial, sans-serif">
				  <g id="pijl">
				      <polyline points="115 76.53 221.06 76.53 221.06 290.53 348.23 290.53" fill="none" stroke="#fff" strokeMiterlimit="10" strokeWidth="12"/>
				      <polygon points="345.78 272.31 345.78 308.75 364 290.53 345.78 272.31" fill="#fff"/>
				  </g>
				  <g id="wolk-statisch" style={styleCloudStatic} transform={'translate(' + this.state.staticX + ')'} fontWeight="700" textAnchor="middle">
				    <path d="M300.77,47.59a46.5,46.5,0,0,0-86.3,2.84c-23.84-14.76-55.06,2.84-55.06,31.23,0,26.11,26.68,43.15,50.52,33.49,9.65,27.82,47.12,33.5,64.16,9.66,16.46,6.81,35.76-2.28,41.44-19.88,14.19-1.7,25.55-14.19,25.55-29.52A29.73,29.73,0,0,0,300.77,47.59Z" fill="#fff"/>
				    <text transform="translate(260 91)" fontSize="12" fill="#a90060">Loonontwikkeling</text>
				    <text transform="translate(250 76)" fontSize="15" fill="#a90060">Statische koopkracht</text>
				    <text transform="translate(270 111)" fontSize="12" fill="#a90060">Inflatie</text>
				    <text transform="translate(215 107)" fontSize="12" fill="#a90060">Beleid</text>
				  </g>
				  <g id="wolk-dynamisch" style={styleCloudDynamic} transform={'translate(' + this.state.dynamicX + ')'} fontWeight="700" fontSize="12" fill="#a90060" textAnchor="middle">
				    <path d="M219.33,218.94a48.78,48.78,0,0,0-90.54,3c-25-15.49-57.79,3-57.79,32.77,0,27.4,28,45.27,53,35.14C134.15,319,173.46,325,191.34,300c17.27,7.15,37.53-2.38,43.48-20.85,14.9-1.79,26.81-14.89,26.81-31A31.2,31.2,0,0,0,219.33,218.94Z" fill="#fff"/>
				    <text transform="translate(200 271)">Scheiding</text>
				    <text transform="translate(150 258)">Nieuwe baan</text>
				    <text transform="translate(160 284)">Ouderschap</text>
				    <text transform="translate(170 242)" fontSize="15">Dynamische koopkracht</text>
				  </g>
				  <g id="dit-jaar" fontSize="13" fill="#fff" fontWeight="700">
				    <path d="M106.28,55.4l-5.13-28.95L5.44,43.4l5.12,28.95A3,3,0,0,0,14,74.78l89.8-15.9A3,3,0,0,0,106.28,55.4ZM89.2,57.57a11.15,11.15,0,1,1,9-12.92A11.14,11.14,0,0,1,89.2,57.57ZM99.27,15.82,3.56,32.76,1.72,22.42A3,3,0,0,1,4.16,19L94,3.05a3,3,0,0,1,3.48,2.43Zm-6.16,34.1A.76.76,0,0,1,93.18,51a7,7,0,0,1-4,2.24A6.89,6.89,0,0,1,82,49.85l-1.9.34a.77.77,0,0,1-.26-1.51l1.54-.27a5.86,5.86,0,0,1-.17-.75,4.92,4.92,0,0,1-.09-.76l-1.55.28a.77.77,0,0,1-.27-1.51l1.9-.33a6.87,6.87,0,0,1,10.08-4.91.76.76,0,0,1,.3,1,.77.77,0,0,1-1,.31,5.23,5.23,0,0,0-3.49-.57,5.33,5.33,0,0,0-4.22,3.85l4.75-.84a.76.76,0,1,1,.27,1.5l-5.21.92a6.68,6.68,0,0,0,.07.77,6.21,6.21,0,0,0,.2.74l5.2-.92a.76.76,0,1,1,.27,1.5l-4.75.84a5.34,5.34,0,0,0,5.28,2.17A5.24,5.24,0,0,0,92,50,.77.77,0,0,1,93.11,49.92Z" />
				    <rect x="1" y="70" width="108" height="63" rx="3" fill="none" stroke="#fff" strokeWidth="1.2" />
				    <text transform="translate(7 90)" >
					    <tspan x="0" y="0">Beschikbaar</tspan>
					    <tspan x="0" y="16">inkomen </tspan>
					    <tspan x="0" y="32">dit jaar</tspan>
				    </text>
				  </g>
				  <g id="volgend-jaar" fontSize="13" fill="#fff" fontWeight="700">>
				    <path d="M476.28,276.4l-5.13-28.95L375.44,264.4l5.12,29a3,3,0,0,0,3.48,2.43l89.8-15.9A3,3,0,0,0,476.28,276.4Zm-17.08,2.17a11.15,11.15,0,1,1,9-12.92A11.14,11.14,0,0,1,459.2,278.57Zm10.07-41.75-95.71,16.94-1.84-10.34a3,3,0,0,1,2.44-3.47l89.8-15.9a3,3,0,0,1,3.48,2.43Zm-6.16,34.1a.76.76,0,0,1,.07,1.08,7,7,0,0,1-4,2.24,6.89,6.89,0,0,1-7.18-3.39l-1.9.34a.77.77,0,0,1-.26-1.51l1.54-.27a5.86,5.86,0,0,1-.17-.75,4.92,4.92,0,0,1-.09-.76l-1.55.28a.77.77,0,1,1-.27-1.51l1.9-.33a6.87,6.87,0,0,1,10.08-4.91.76.76,0,0,1,.3,1,.77.77,0,0,1-1,.31,5.23,5.23,0,0,0-3.49-.57,5.33,5.33,0,0,0-4.22,3.85l4.75-.84a.76.76,0,1,1,.27,1.5l-5.21.92a6.68,6.68,0,0,0,.07.77,6.21,6.21,0,0,0,.2.74l5.2-.92a.76.76,0,1,1,.27,1.5l-4.75.84a5.34,5.34,0,0,0,5.28,2.17A5.24,5.24,0,0,0,462,271,.77.77,0,0,1,463.11,270.92Z" />
				    <rect x="371" y="291" width="108" height="63" rx="3" fill="none" stroke="#fff" strokeWidth="1.2" />
				    <text transform="translate(377 312)" >
					    <tspan x="0" y="0">Beschikbaar</tspan>
					    <tspan x="0" y="16">inkomen</tspan>
					    <tspan x="0" y="32">volgend jaar</tspan>
				    </text>
				  </g>

			  </g>
			</svg>

	  	)
	}
}

export default VisWat;



// WEBPACK FOOTER //
// ./src/components/Visualization/VisWat.js